import { render, staticRenderFns } from "./ModalConfirmados.vue?vue&type=template&id=2ca0c8b0&scoped=true"
import script from "./ModalConfirmados.vue?vue&type=script&lang=js"
export * from "./ModalConfirmados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca0c8b0",
  null
  
)

export default component.exports